export type ButtonProps = {
  title: string;
  type?: ButtonType;
  onClick?: () => any;
  disabled?: boolean;
  loading?: boolean;
};

export enum ButtonType {
  Primary = "primary",
  Secondary = "secondary",
}
